import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import { Button } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_CHAR_LIMIT, DEFAULT_SEE_LESS, DEFAULT_SEE_MORE } from './ExpandableText.constants';
import { contentExceedsCharLimit, getButtonText, getCurrentContent, getShortenedText } from './ExpandableText.utils';
import { DEFAULT_ANIMATION_DELAY } from '../../../animations/animation.constants';
import AnimateHeight from '../../../animations/components/AnimatedElement/variants/AnimateHeight';
import Icon from '../Icon';
import './ExpandableText.css';
var defaultProps = {
  charLimit: DEFAULT_CHAR_LIMIT,
  disableExpanding: false,
  onExpand: null,
  expandButton: null,
  seeMoreText: DEFAULT_SEE_MORE,
  seeLessText: DEFAULT_SEE_LESS,
  seeMoreIcon: '',
  seeLessIcon: ''
};
export default function ExpandableText(_ref) {
  var text = _ref.text,
    charLimit = _ref.charLimit,
    disableExpanding = _ref.disableExpanding,
    onExpand = _ref.onExpand,
    expandButton = _ref.expandButton,
    seeMoreText = _ref.seeMoreText,
    seeLessText = _ref.seeLessText,
    seeMoreIcon = _ref.seeMoreIcon,
    seeLessIcon = _ref.seeLessIcon;
  var ref = useRef(null);
  var _useState = useState(getCurrentContent(text, charLimit)),
    _useState2 = _slicedToArray(_useState, 2),
    currentContent = _useState2[0],
    setCurrentContent = _useState2[1];
  var _useState3 = useState('auto'),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  if (_isEmpty(text)) {
    return null;
  }
  function onSeeClick() {
    if (onExpand) {
      onExpand();
    } else {
      var shrinking = currentContent === text;
      setHeight(ref.current.clientHeight);
      setTimeout(function () {
        var newContent = shrinking ? getShortenedText(text, charLimit) : text;
        setCurrentContent(newContent);
        setHeight('auto');
      }, DEFAULT_ANIMATION_DELAY);
    }
  }
  var displaySeeButton = !disableExpanding && contentExceedsCharLimit(text, charLimit);
  var _getButtonText = getButtonText(text, currentContent, {
      seeMoreText: seeMoreText,
      seeLessText: seeLessText,
      seeMoreIcon: seeMoreIcon,
      seeLessIcon: seeLessIcon
    }),
    buttonContent = _getButtonText.buttonContent,
    isIcon = _getButtonText.isIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: "expandable-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container",
    ref: ref
  }, /*#__PURE__*/React.createElement(AnimateHeight, {
    height: height
  }, currentContent)), displaySeeButton && (expandButton || /*#__PURE__*/React.createElement(Button, {
    onClick: onSeeClick,
    content: isIcon ? '' : buttonContent,
    icon: isIcon ? /*#__PURE__*/React.createElement(Icon, {
      iconName: buttonContent
    }) : false
  })));
}
ExpandableText.defaultProps = defaultProps;